const chainNodes = [
  { x: "left-0 top-[200px]", label: "市场采购", active: false, icon: "ri-shopping-basket-line" },
  { x: "left-[212px] top-[180px]", label: "报关申报", active: true, icon: "ri-file-list-3-line" },
  { x: "left-[424px] top-[200px]", label: "阳光收汇", active: false, icon: "ri-exchange-funds-line" },
  { x: "left-[636px] top-[180px]", label: "结汇到账", active: false, icon: "ri-bank-line" },
  { x: "left-[848px] top-[200px]", label: "留痕归档", active: false, icon: "ri-archive-line" },
];

export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center pt-16 md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20stylized%20illustration%20of%20international%20market%20procurement%20trade%20and%20global%20logistics%2C%20colorful%20shipping%20containers%20and%20cargo%20cranes%20at%20a%20busy%20port%2C%20warm%20golden%20sunrise%20light%2C%20clean%20minimal%20flat%20design%20aesthetic%20with%20teal%20and%20orange%20gradient%20tones%2C%20abstract%20geometric%20shapes%2C%20editorial%20composition%2C%20high%20detail%2C%20harmonious%20and%20professional&width=1600&height=900&seq=market-trade-hero&orientation=landscape"
          alt="市场采购贸易背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-50/70 via-background-50/50 to-primary-50/60" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/90 via-background-50/50 to-transparent" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-center">
          <div className="space-y-6 md:space-y-8">
            <span className="inline-flex items-center gap-2 bg-background-50 border border-primary-200 rounded-full px-4 py-2">
              <i className="ri-sparkling-line text-primary-600" />
              <span className="text-sm font-medium text-primary-700">
                市场采购贸易 · 1039 一站式数字化平台
              </span>
            </span>

            <h1 className="text-[30px] md:text-[52px] lg:text-[60px] font-heading font-extrabold leading-[1.16] tracking-tight">
              <span className="bg-gradient-to-r from-primary-600 to-primary-500 bg-clip-text text-transparent">
                市场采购贸易
              </span>
              <br />
              <span className="text-foreground-950 mt-2 inline-block">
                一站式数字化服务平台
              </span>
            </h1>

            <div className="space-y-2">
              <p className="text-base md:text-lg text-foreground-700 font-medium">
                小商品、多品种、小批量出口，从"没法出口"升级为"阳光合规出海"。
              </p>
              <p className="text-[15px] md:text-[17px] text-foreground-500">
                无票采购也能出口、免征不退、简化通关、阳光收汇，一套平台稳定跑通。
              </p>
            </div>

            <div className="space-y-3 md:space-y-4 max-w-[340px] pt-2">
              <a
                href="#pricing"
                className="w-full h-14 bg-gradient-to-r from-accent-500 to-accent-400 text-background-50 font-medium text-base rounded-full hover:-translate-y-0.5 transition-all flex items-center justify-center gap-2"
              >
                查看服务与价格
              </a>
              <a
                href="#plans"
                className="w-full h-14 bg-background-50 border border-primary-500 text-primary-600 font-medium text-base rounded-full hover:bg-primary-50 transition-all flex items-center justify-center"
              >
                查看适用场景
              </a>
              <a
                href="#experience"
                className="w-full h-10 text-primary-700 text-sm font-medium hover:text-primary-800 hover:underline transition-all flex items-center justify-center gap-1"
              >
                先跑通一单
              </a>
            </div>

            <div className="pt-2">
              <div className="flex items-start gap-2">
                <span className="w-1 h-3.5 bg-accent-500 rounded-full flex-shrink-0 mt-1" />
                <span className="text-xs text-foreground-500 leading-relaxed">
                  <strong className="text-foreground-700 font-medium">
                    合规说明:
                  </strong>
                  平台提供采购、报关、收汇、结汇数字化服务，不承诺放行/收汇审批结果。
                </span>
              </div>
            </div>
          </div>

          <div className="relative h-[420px] md:h-[500px] hidden lg:flex items-center justify-center">
            <svg
              className="absolute inset-0 w-full h-full text-primary-200"
              viewBox="0 0 900 420"
              fill="none"
              preserveAspectRatio="xMidYMid meet"
            >
              <path
                d="M20 210 H 880"
                stroke="currentColor"
                strokeWidth="2"
                strokeDasharray="6 8"
              />
              <circle cx="20" cy="210" r="6" fill="currentColor" />
              <circle cx="880" cy="210" r="6" fill="currentColor" />
            </svg>

            {chainNodes.map((node, i) => (
              <div key={i} className={`absolute ${node.x} flex flex-col items-center`}>
                <div
                  className={`w-14 h-14 rounded-full flex items-center justify-center transition-all duration-500 ${
                    node.active
                      ? "bg-primary-500 shadow-lg shadow-primary-500/40 scale-110 relative"
                      : "bg-background-50 border border-primary-200 hover:border-primary-400"
                  }`}
                >
                  {node.active && (
                    <span className="absolute inset-0 rounded-full bg-primary-500 opacity-30 animate-ping" />
                  )}
                  <i
                    className={`text-xl ${
                      node.active
                        ? "text-background-50"
                        : "text-primary-500"
                    } ${node.icon}`}
                  />
                </div>
                <span
                  className={`mt-4 text-[13px] whitespace-nowrap font-medium ${
                    node.active ? "text-primary-700 font-bold" : "text-foreground-500"
                  }`}
                >
                  {node.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}